"use client"

import type { FunctionComponent, PropsWithChildren } from "react"

import { TranslationProvider } from "@/modules/i18n/components/TranslationProvider"

export const AppTranslationProviderWrapper: FunctionComponent<PropsWithChildren> = ({ children }) => {
  return <TranslationProvider>{children}</TranslationProvider>
}
